// VehTypeGroupCodeSelect.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import {
    DialogContent, DialogActions, Button,
} from '@mui/material';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import DoneIcon from '@mui/icons-material/Done'; // done
import CloseIcon from '@mui/icons-material/Close'; // cancel
import { AppObject, AppStyle, AppWord } from '../../value/AppConst';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import DraggableViewer from '../../common/DraggableViewer';
import { LIST_VEH_TYPE_GROUP_CODE } from './VehTypeGroupCodeGql';
import { useAlertSetter } from '../../api/app-hook';
import { VehTypeGroupCodeDictionary } from './VehTypeGroupCodeDict';
import { vehTypeGroupCodeListRepo } from '../../value/AppModel';

const ViewContainer = styled(Box)({
    marginTop: 10
});

const RecordBox = styled(Box)({
    display:'flex', alignItems:'center', borderBottom:AppStyle.BorderCCC, cursor:'pointer', padding:5,
});
const CodeBox = styled(Box)({width:80, padding: 5});
const NameBox = styled(Box)({width:200, padding: 5});

export default function VehTypeGroupCodeSelect({
    open,
    vehTypeGroup,
    onClose,
    onSelect,
}) {
    const [groupSelected, setGroupSelected] = useState(false);
    const vehTypeGroupCodeListData = useReactiveVar(vehTypeGroupCodeListRepo);
    const addAlert = useAlertSetter();

    useEffect(()=>{
        if(open && vehTypeGroup) setGroupSelected(vehTypeGroup);
    }, [open, vehTypeGroup]);

    // ##### Call GraphQL to get List #####
    const [getVehTypeGroupCodeList, responseList] = useLazyQuery(LIST_VEH_TYPE_GROUP_CODE, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetList(data, option)},
		onError: (error) => addAlert({title: VehTypeGroupCodeDictionary.errorTitle.Get, message: [error.message]})
    });

    const getVehTypeGroupCodeListNow = () => {
        getVehTypeGroupCodeList();
    };

    useEffect(() => {
        const diff = new Date().getTime()/1000 - vehTypeGroupCodeListData.when;
        if(diff > 60)
            getVehTypeGroupCodeListNow();
    }, [open]);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetList = (data, clientOption) => {
        if(data.vehTypeGroupCodeList) {
            vehTypeGroupCodeListRepo({when:new Date().getTime()/1000, records:data.vehTypeGroupCodeList});
        }
    };

    const onClickRequestSelect = () => {
        if(groupSelected && groupSelected.vehTypeGpCd !== vehTypeGroup.vehTypeGpCd) {
            onSelect(groupSelected);
        }
    };

    if(!open) return null;

    return(
        <DraggableViewer open={open} onClose={onClose} maxWidth='lg'
            title={
                <>
                <MenuBookIcon fontSize={AppWord.LARGE} style={{color:'white', marginRight:15}}/>
                {vehTypeGroup.dcName}에 대한 차종그룹 {vehTypeGroup.vehTypeGpCd ? '변경' : '설정'}
                </>
            }
        >
            <DialogContent>
                <ViewContainer>
                    {
                        vehTypeGroupCodeListData.records.map((record, index) => {
                            return (
                                <RecordBox key={index} onClick={()=>setGroupSelected(record)}>
                                    {
                                        groupSelected &&
                                        groupSelected.vehTypeGpCd === record.vehTypeGpCd ?
                                        <CheckBoxIcon fontSize={AppWord.SMALL} color={AppStyle.mui.primary} /> :
                                        <CheckBoxOutlineBlankIcon fontSize={AppWord.SMALL} style={{color:'#777'}} />
                                    }
                                    <CodeBox>{record.vehTypeGpCd}</CodeBox>
                                    <NameBox>{record.groupName}</NameBox>
                                </RecordBox>
                            );
                        })
                    }
                </ViewContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClickRequestSelect}
                    variant={AppStyle.mui.contained}
                    color={AppStyle.mui.primary}
                    sx={{width: 120}}
                    startIcon={<DoneIcon />}
                    disabled={
                        !groupSelected || groupSelected.vehTypeGpCd === vehTypeGroup.vehTypeGpCd
                        || responseList.loading
                    }
                >
                    {vehTypeGroup && vehTypeGroup.vehTypeGpCd ? '변경' : '등록'}
                </Button>
                <Button onClick={onClose}
                    variant={AppStyle.mui.contained}
                    color={AppStyle.mui.warning}
                    sx={{width: 120}}
                    startIcon={<CloseIcon />}
                >
                    취소
                </Button>
            </DialogActions>
        </DraggableViewer>
    );
}
